const ITEMS = ["Live almost daily", "$500 monthly leaderboard", "Regular giveaways", "Code DAFABER", "Kick · Discord · X"];

const Row = ({ hidden }) => (
  <div className="marquee-row" aria-hidden={hidden}>
    {ITEMS.map((t) => (
      <span key={t} className="flex items-center gap-8 pr-8">
        <span className="marquee-text">{t}</span>
        <img src="/assets/roobet-icon.png" alt="" className="h-8 w-8 sm:h-10 sm:w-10" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="marquee border-y border-white/15 py-6 sm:py-8" data-testid="editorial-marquee">
    <div className="marquee-track">
      <Row />
      <Row hidden />
    </div>
  </section>
);
